import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import AboutPage from "../pages/about/page";
import WhyUsPage from "../pages/why-us/page";
import ContactPage from "../pages/contact/page";
import RixinPage from "../pages/rixin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/productos",
    element: <ProductsPage />,
  },
  {
    path: "/nosotros",
    element: <AboutPage />,
  },
  {
    path: "/diferenciadores",
    element: <WhyUsPage />,
  },
  {
    path: "/contacto",
    element: <ContactPage />,
  },
  {
    path: "/rixin",
    element: <RixinPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;